import { AcademyCourse } from '../../models/academy-course.model';

export const rulesCourse: AcademyCourse = {
  slug: 'rules-of-the-platform',
  trainingModuleId: 'platform_rules',
  titleKey: 'texts.Tutor_Academy_Course_Rules_Title',
  descriptionKey: 'texts.Tutor_Academy_Course_Rules_Description',
  isMandatory: true,
  hasSearchBoost: false,
  lessons: [
    {
      id: 'contactgegevens',
      titleKey: 'texts.Tutor_Academy_Rules_L1_Title',
      subtitleKey: 'texts.Tutor_Academy_Rules_L1_Subtitle',
      type: 'text',
      blocks: [
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Rules_L1_Paragraph1' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Rules_L1_Paragraph2' },
        {
          type: 'list',
          itemKeys: [
            'texts.Tutor_Academy_Rules_L1_Item1',
            'texts.Tutor_Academy_Rules_L1_Item2',
            'texts.Tutor_Academy_Rules_L1_Item3'
          ]
        },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Rules_L1_Paragraph3' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Rules_L1_Paragraph4' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Rules_L1_Paragraph5' }
      ]
    },
    {
      id: 'buiten-het-platform',
      titleKey: 'texts.Tutor_Academy_Rules_L2_Title',
      subtitleKey: 'texts.Tutor_Academy_Rules_L2_Subtitle',
      headingKey: 'texts.Tutor_Academy_Rules_L2_Heading',
      type: 'text',
      blocks: [
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Rules_L2_Paragraph1' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Rules_L2_Paragraph2' },
        {
          type: 'list',
          itemKeys: [
            'texts.Tutor_Academy_Rules_L2_Item1',
            'texts.Tutor_Academy_Rules_L2_Item2',
            'texts.Tutor_Academy_Rules_L2_Item3'
          ]
        },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Rules_L2_Paragraph3' }
      ]
    },
    {
      id: 'prijzen-en-pakketten',
      titleKey: 'texts.Tutor_Academy_Rules_L3_Title',
      subtitleKey: 'texts.Tutor_Academy_Rules_L3_Subtitle',
      type: 'text',
      blocks: [
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Rules_L3_Paragraph1' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Rules_L3_Paragraph2' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Rules_L3_Paragraph3' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Rules_L3_Paragraph4' }
      ]
    },
    {
      id: 'veiligheid-en-respect',
      titleKey: 'texts.Tutor_Academy_Rules_L4_Title',
      subtitleKey: 'texts.Tutor_Academy_Rules_L4_Subtitle',
      type: 'text',
      blocks: [
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Rules_L4_Paragraph1' },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Rules_L4_Paragraph2' },
        {
          type: 'list',
          itemKeys: [
            'texts.Tutor_Academy_Rules_L4_Item1',
            'texts.Tutor_Academy_Rules_L4_Item2',
            'texts.Tutor_Academy_Rules_L4_Item3',
            'texts.Tutor_Academy_Rules_L4_Item4'
          ]
        },
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Rules_L4_Paragraph3' }
      ]
    },
    {
      id: 'goed-om-te-weten',
      titleKey: 'texts.Tutor_Academy_Rules_L5_Title',
      subtitleKey: 'texts.Tutor_Academy_Rules_L5_Subtitle',
      type: 'text',
      blocks: [
        { type: 'paragraph', textKey: 'texts.Tutor_Academy_Rules_L5_Paragraph1' },
        {
          type: 'list',
          itemKeys: [
            'texts.Tutor_Academy_Rules_L5_Item1',
            'texts.Tutor_Academy_Rules_L5_Item2',
            'texts.Tutor_Academy_Rules_L5_Item3',
            'texts.Tutor_Academy_Rules_L5_Item4',
            'texts.Tutor_Academy_Rules_L5_Item5'
          ]
        },
        {
          type: 'paragraph',
          textKey: 'texts.Tutor_Academy_Rules_L5_Paragraph2',
          linkLabelKey: 'texts.Tutor_Academy_Rules_L5_Bonus_Label',
          linkParam: 'bonusPage',
          linkUrl: '/Navigation_tutor_bonus'
        }
      ]
    }
  ],
  quiz: [
    {
      id: 'contactgegevens',
      questionKey: 'texts.Tutor_Academy_Rules_Q1_Question',
      isMultiSelect: false,
      answers: [
        { id: 'nummer-geven', textKey: 'texts.Tutor_Academy_Rules_Q1_Answer1' },
        { id: 'chat-gebruiken', textKey: 'texts.Tutor_Academy_Rules_Q1_Answer2' }
      ],
      correctAnswerIds: ['chat-gebruiken'],
      explanationKey: 'texts.Tutor_Academy_Rules_Q1_Explanation'
    },
    {
      id: 'boete',
      questionKey: 'texts.Tutor_Academy_Rules_Q2_Question',
      isMultiSelect: false,
      answers: [
        { id: 'nummer-delen', textKey: 'texts.Tutor_Academy_Rules_Q2_Answer1' },
        { id: 'buiten-platform', textKey: 'texts.Tutor_Academy_Rules_Q2_Answer2' }
      ],
      correctAnswerIds: ['buiten-platform'],
      explanationKey: 'texts.Tutor_Academy_Rules_Q2_Explanation'
    },
    {
      id: 'buiten-het-platform',
      questionKey: 'texts.Tutor_Academy_Rules_Q3_Question',
      isMultiSelect: true,
      answers: [
        { id: 'uitleggen', textKey: 'texts.Tutor_Academy_Rules_Q3_Answer1' },
        { id: 'akkoord', textKey: 'texts.Tutor_Academy_Rules_Q3_Answer2' },
        { id: 'nadenken', textKey: 'texts.Tutor_Academy_Rules_Q3_Answer3' },
        { id: 'eenmalig', textKey: 'texts.Tutor_Academy_Rules_Q3_Answer4' }
      ],
      correctAnswerIds: ['uitleggen'],
      explanationKey: 'texts.Tutor_Academy_Rules_Q3_Explanation'
    },
    {
      id: 'prijzen',
      questionKey: 'texts.Tutor_Academy_Rules_Q4_Question',
      isMultiSelect: false,
      answers: [
        { id: 'schatting', textKey: 'texts.Tutor_Academy_Rules_Q4_Answer1' },
        { id: 'doorverwijzen', textKey: 'texts.Tutor_Academy_Rules_Q4_Answer2' }
      ],
      correctAnswerIds: ['doorverwijzen'],
      explanationKey: 'texts.Tutor_Academy_Rules_Q4_Explanation'
    }
  ]
};
